import { GameModeCards } from './GameModeCards.jsx';
import { RunPreviewGrid } from './RunPreviewGrid.jsx';

export function RunModeSetup({
  session,
  modes,
  selectedModeId,
  stage,
  preview,
  error,
  hubState,
  config,
  onSelect,
  onReview,
  onStart,
  onRetryCurrent,
  onSignOut,
  onPlayOffline,
}) {
  const loadingCurrent = stage === 'loading-current';
  const reviewing = stage === 'preview-loading';
  const starting = stage === 'starting';
  const blocked = loadingCurrent || reviewing || starting;

  return (
    <main className="run-mode-shell">
      <section className="run-mode-card" aria-labelledby="run-mode-title">
        <header className="run-mode-header">
          <img src="./branding/the-dope-man-logo.webp" alt="The Dope Man" />
          <div className="run-mode-heading-copy">
            <div className="eyebrow">PLAYER: {session?.player?.alias || 'UNKNOWN'}</div>
            <h1 id="run-mode-title">Choose your run</h1>
            <p>Pick the rules for this run. The hub verifies the final start values before anything is created.</p>
          </div>
          <span className={`hub-badge ${String(hubState).toLowerCase()}`}>{hubState}</span>
        </header>

        <div className="run-mode-scroll" data-testid="run-mode-scroll-region">
          {loadingCurrent ? (
            <div className="run-mode-working" aria-live="polite">
              <div className="dope-spinner"><span /></div>
              <h2>Checking for an existing run…</h2>
              <p>The server is making sure we do not create a duplicate or replace anything already in progress.</p>
            </div>
          ) : (
            <>
              <section className="run-path-panel" aria-labelledby="run-path-title">
                <div className="run-path-heading">
                  <div>
                    <div className="eyebrow">CHOOSE YOUR PATH</div>
                    <h2 id="run-path-title">How do you want to play?</h2>
                  </div>
                  <p>Classic, Long Haul, and Career use the same neighborhoods, encounters, shops, characters, inventory, and event pack; only pacing and end conditions change.</p>
                </div>
                <GameModeCards
                  modes={modes}
                  selectedModeId={selectedModeId}
                  onSelect={onSelect}
                  disabled={blocked}
                  legend="Select the rules for this new run"
                />
              </section>

              {reviewing && (
                <div className="run-mode-working compact" aria-live="polite">
                  <div className="dope-spinner"><span /></div>
                  <h2>Getting the server’s fine print…</h2>
                </div>
              )}

              {stage === 'confirm' && preview && (
                <section className="run-mode-preview" aria-live="polite">
                  <div className="run-mode-preview-heading">
                    <div><div className="eyebrow">AUTHORITATIVE RUN PREVIEW</div><h2>Review before entering the streets</h2></div>
                    <span>Expires soon</span>
                  </div>
                  <RunPreviewGrid preview={preview} />
                  <p className="fine-print">The browser selects only the mode ID. The hub independently chooses and verifies every debt, difficulty, event-pack, and run-start value.</p>
                </section>
              )}

              {starting && (
                <div className="run-mode-working compact" aria-live="assertive">
                  <div className="dope-spinner burn"><span /></div>
                  <h2>Starting the run…</h2>
                  <p>Creating one authoritative save. Repeated taps cannot create extra runs.</p>
                </div>
              )}

              {stage === 'error' && <div className="form-error run-mode-error" role="alert">{error || 'The server refused to prepare the run.'}</div>}
            </>
          )}
        </div>

        <footer className="run-mode-footer">
          <div className="run-mode-actions">
            {stage !== 'confirm' && !starting && !loadingCurrent && (
              <button className="btn buy primary-action" type="button" onClick={() => onReview(selectedModeId)} disabled={blocked}>Review Starting Rules</button>
            )}
            {stage === 'confirm' && (
              <button className="btn buy primary-action" type="button" onClick={onStart} disabled={blocked}>Start This Run</button>
            )}
            {stage === 'error' && <button className="btn" type="button" onClick={onRetryCurrent}>Try Again</button>}
            <button className="btn" type="button" onClick={onSignOut} disabled={blocked}>Sign Out</button>
            <button className="btn sell" type="button" onClick={onPlayOffline} disabled={blocked}>Play Offline Classic</button>
          </div>
          <div className="build-line">Client {config.appVersion} · {config.runtime}</div>
        </footer>
      </section>
    </main>
  );
}
